module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.send
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "dark": ""
    }
  }, [_c('invoice-list-item', {
    attrs: {
      "invoice": _vm.invoiceDetail
    }
  }, [_c('template', {
    slot: "actionsAfter"
  }, [_c('v-list-tile-action', [_c('strong', {
    staticClass: "subheading mt-3"
  }, [_vm._v("\n                " + _vm._s(_vm.formatCurrency(_vm.invoiceDetail.currency, _vm.invoiceDetail.amount_due)) + "\n              ")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("Due")])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.requests.get.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.invoicePreviewUrl) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "target": "_blank",
      "href": _vm.invoicePreviewUrl
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1) : _vm._e()], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("Medical Aid Information as displayed on invoice:")]), _vm._v(" "), _c('pre', {
    staticClass: "text-small mad pa-2"
  }, [_vm._v(_vm._s(_vm.invoiceDetail.medicalaid_details))]), _vm._v(" "), _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("\n              Choose a medical aid\n            ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "readonly": "",
      "outline": "",
      "persistent-hint": "",
      "value": _vm.medicalaid.name,
      "hint": _vm.medicalAidHint,
      "label": "medical aid",
      "append-icon": "arrow_drop_down"
    },
    on: {
      "click:append": function($event) {
        _vm.choosemedicalaiddialog = true
      },
      "click": function($event) {
        _vm.choosemedicalaiddialog = true
      }
    }
  }), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("\n              Use a custom email\n              "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("\n              Custom email address\n            ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "outline": "",
      "persistent-hint": "",
      "clearable": "",
      "type": "email",
      "hint": "Write the email address for the medical aid you want to send this invoice to",
      "label": "Enter an email address"
    },
    model: {
      value: (_vm.customemail),
      callback: function($$v) {
        _vm.customemail = $$v
      },
      expression: "customemail"
    }
  }), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n              Search for an email\n            ")], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.choosemedicalaiddialog),
      callback: function($$v) {
        _vm.choosemedicalaiddialog = $$v
      },
      expression: "choosemedicalaiddialog"
    }
  }, [_c('v-sheet', {
    attrs: {
      "height": "600"
    }
  }, [_c('medical-aid-picker', {
    on: {
      "input": function($event) {
        _vm.choosemedicalaiddialog = false
      }
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), (_vm.medicalAidEmail) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0 pt-0",
    model: {
      value: (_vm.sendFrom),
      callback: function($$v) {
        _vm.sendFrom = $$v
      },
      expression: "sendFrom"
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Send from\n                "), _c('help-popover', {
    staticClass: "ml-4"
  }, [_vm._v("\n                  The medical aid will send status updates to this email address\n                ")])], 1), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "value": "me",
      "label": "Send from my email address",
      "hint": "Replies and notifications from medical aid will come to this email address"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "disabled": !_vm.clientHasEmail,
      "value": "client",
      "label": "Send from the client's email address",
      "hint": "Replies and notifications from medical aid will be sent to your client"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0 pt-0",
    model: {
      value: (_vm.reimburse),
      callback: function($$v) {
        _vm.reimburse = $$v
      },
      expression: "reimburse"
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("\n                Who should be re-imbursed\n                "), _c('help-popover', {
    staticClass: "ml-4"
  }, [_vm._v("\n                  We'll add a note to the email.\n                  We can't guarantee the provider will necessary get this right though\n                ")])], 1), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "value": "me",
      "label": "Me"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "persistent-hint": "",
      "value": "client",
      "label": "Client"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "cc me on the email"
    },
    model: {
      value: (_vm.ccme),
      callback: function($$v) {
        _vm.ccme = $$v
      },
      expression: "ccme"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.medicalAidEmail) ? _c('div', {
    staticClass: "blue lighten-4 pa-1 px-3"
  }, [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n              Invoice will be sent")], 1), _vm._v(" "), (_vm.step === 0) ? _c('div', [_vm._v("\n              to: "), _c('strong', [_vm._v(_vm._s(_vm.medicalaid.name) + " «" + _vm._s(_vm.medicalAidEmail) + "»")])]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', [_vm._v("\n              to: "), _c('strong', [_vm._v("«" + _vm._s(_vm.medicalAidEmail) + "»")])]) : _vm._e(), _vm._v(" "), (_vm.fromPerson && _vm.fromPerson.email) ? _c('div', [_vm._v("\n              from: "), _c('strong', [_vm._v(_vm._s(_vm.fromPerson.first_name) + " " + _vm._s(_vm.fromPerson.last_name) + " «" + _vm._s(_vm.fromPerson.email) + "»")])]) : _vm._e(), _vm._v(" "), (_vm.ccme) ? _c('div', [_vm._v("\n              cc: "), _c('strong', [_vm._v(_vm._s(_vm.me.first_name) + " " + _vm._s(_vm.me.last_name) + " «" + _vm._s(_vm.me.email) + "»")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [(_vm.withCancel) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.send.loading,
      "disabled": !_vm.medicalAidEmail,
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send\n          "), _c('v-icon', {
    staticClass: "ml-2 small"
  }, [_vm._v("send")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "flat": ""
    }
  }, [_c('center', [
    [_c('h3', {
      staticClass: "pt-4 headline"
    }, [_vm._v("Invoice submitted")]), _vm._v(" "), _c('v-icon', {
      staticClass: "pa-4",
      attrs: {
        "size": "72",
        "color": "success"
      }
    }, [_vm._v("check_circle")]), _vm._v(" "), _c('message-delivery-status', {
      attrs: {
        "batch-id": _vm.batchId
      }
    })]
  ], 2), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-5"
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit("close");
        _vm.window = 0
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68985aff","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/SendToMedicalAid.vue
// module id = 1454
// module chunks = 9